/* Product layout controller; the shared personalizer owns design and proof creation. */
(function () {
  'use strict';

    function mount(section) {
      if (!section || section.dataset.hahDetailReady === 'true') return;
      section.dataset.hahDetailReady = 'true';
      var variantsNode = section.querySelector('[data-hah-variants]');
      var variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
      var currency = section.dataset.currency || 'USD';
      var pricePending = section.dataset.pricePending === 'true';
      var conversionApi = window.HahConversion;
      var conversionNode = section.querySelector('[data-hah-conversion]');
      var conversionPayload = {};
      try { conversionPayload = JSON.parse(conversionNode ? conversionNode.textContent : '{}') || {}; } catch (error) {}
      var conversion = conversionApi ? conversionApi.config(conversionPayload.config) : { enabled: { savings: false } };
      var variantInput = section.querySelector('[data-hah-variant-id]');
      var currentPrice = section.querySelector('[data-hah-current]');
      var comparePrice = section.querySelector('[data-hah-compare]');
      var saving = section.querySelector('[data-hah-saving]');
      var offersNode = section.querySelector('[data-hah-offers]'), offersTimer = null, offersSignature = null;
      var atc = section.querySelector('[data-hah-atc]');
      var message = section.querySelector('[data-hah-form-message]');
      var form = section.querySelector('form[action*="/cart/add"]');
      var mainImage = section.querySelector('[data-hah-main-image]');
      var activeGalleryImage = mainImage;
      var bufferGalleryImage = null;
      var gallerySwitchToken = 0;

      if (mainImage) {
        mainImage.classList.add('is-active');
        bufferGalleryImage = mainImage.cloneNode(false);
        bufferGalleryImage.removeAttribute('data-hah-main-image');
        bufferGalleryImage.setAttribute('data-hah-main-image-buffer', '');
        bufferGalleryImage.setAttribute('aria-hidden', 'true');
        bufferGalleryImage.alt = '';
        bufferGalleryImage.classList.remove('is-active', 'is-switching');
        mainImage.after(bufferGalleryImage);
      }

      function money(cents) {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency, currencyDisplay: 'narrowSymbol' }).format((Number(cents) || 0) / 100) + ' ' + currency;
      }

      function selectedOptions() {
        return Array.from(section.querySelectorAll('[data-hah-option-index]')).map(function (group) {
          var checked = group.querySelector('input:checked');
          return checked ? checked.value : '';
        });
      }

      function findVariant() {
        var options = selectedOptions();
        if (!options.length) return variants.find(function (variant) { return variantInput && String(variant.id) === variantInput.value; }) || variants[0];
        return variants.find(function (variant) {
          return options.every(function (value, index) {
            return variant.options[index] === value;
          });
        });
      }

      function currentOffers() {
        var variant = findVariant();
        return !pricePending && variant && variant.available && conversionApi && conversionApi.offerInfo ?
          conversionApi.offerInfo(conversion, conversionPayload.offers, section.dataset.productId, String(variant.id), currency, Date.now()) : [];
      }
      function refreshOffers() {
        if (!offersNode) return;
        if (offersTimer !== null) { window.clearTimeout(offersTimer); offersTimer = null; }
        if (section.isConnected === false) return;
        var items = currentOffers(), signature = JSON.stringify(items);
        offersNode.hidden = !items.length;
        if (signature !== offersSignature) {
          offersSignature = signature; offersNode.replaceChildren();
          items.forEach(function (item) {
            var card = document.createElement('div'), copy = document.createElement('div'), heading = document.createElement('strong'), conditions = document.createElement('p'), code = document.createElement('span'), button = document.createElement('button'), feedback = document.createElement('span');
            card.className = 'hah-detail-offer'; card.dataset.hahVerifiedOffer = item.code;
            var benefit = item.benefit, minimum = item.minimum, restrictions = [];
            heading.textContent = benefit.type === 'percentage' ? Number(benefit.value) + '% off eligible items' :
              new Intl.NumberFormat('en', { style: 'currency', currency: currency }).format(Number(benefit.value)) + (benefit.per_item ? ' off each eligible item' : ' off eligible items');
            if (minimum.type === 'quantity') restrictions.push('Minimum ' + Number(minimum.value) + ' eligible items.');
            if (minimum.type === 'subtotal') restrictions.push('Minimum purchase ' + new Intl.NumberFormat('en', { style: 'currency', currency: currency }).format(Number(minimum.value)) + ' of eligible items.');
            if (item.scope.type === 'variants') restrictions.push('Applies to this selected style.');
            restrictions.push(Object.keys(item.combines_with).some(function (key) { return item.combines_with[key]; }) ? 'Eligibility and combining with other offers are confirmed at checkout.' : 'Cannot be combined with other discounts.');
            if (item.ends_at) restrictions.push('Ends ' + new Intl.DateTimeFormat('en', { year:'numeric',month:'short',day:'numeric',hour:'2-digit',minute:'2-digit',timeZone:'UTC' }).format(new Date(item.ends_at)) + ' UTC.');
            restrictions.push('Enter the code at checkout; Shopify confirms eligibility.');
            conditions.className = 'hah-detail-offer-conditions'; conditions.textContent = restrictions.join(' ');
            code.textContent = 'Code: ' + item.code; copy.appendChild(heading); copy.appendChild(code); copy.appendChild(conditions);
            button.type = 'button'; button.textContent = 'Copy code'; button.setAttribute('aria-label', 'Copy verified offer code ' + item.code);
            feedback.className = 'hah-detail-offer-status'; feedback.setAttribute('role','status'); feedback.setAttribute('aria-live','polite');
            button.addEventListener('click', function () {
              if (!currentOffers().some(function (current) { return current.code === item.code; })) { refreshOffers(); return; }
              button.disabled = true;
              Promise.resolve().then(function () { if (!navigator.clipboard || !navigator.clipboard.writeText) throw Error('Clipboard unavailable'); return navigator.clipboard.writeText(item.code); })
                .then(function () { feedback.textContent = 'Code copied'; })
                .catch(function () { feedback.textContent = 'Copy this code: ' + item.code; })
                .finally(function () { button.disabled = false; });
            });
            card.appendChild(copy); card.appendChild(button); card.appendChild(feedback); offersNode.appendChild(card);
          });
        }
        // Expire at the exact next boundary, including while the page remains open.
        var deadlines = [conversionPayload.offers && conversionPayload.offers.expires_at];
        (conversionPayload.offers && Array.isArray(conversionPayload.offers.items) ? conversionPayload.offers.items : []).forEach(function (item) { deadlines.push(item.expires_at, item.ends_at, item.starts_at); });
        var next = deadlines.map(function (value) { return typeof value === 'string' ? Date.parse(value) : NaN; }).filter(function (value) { return Number.isFinite(value) && value > Date.now(); });
        if (next.length) offersTimer = window.setTimeout(refreshOffers, Math.min(2147483647, Math.max(1, Math.min.apply(Math, next) - Date.now())));
      }

      function updateVariant() {
        var variant = findVariant();
        refreshOffers();
        section.querySelectorAll('[data-hah-option-index]').forEach(function (group) {
          var checked = group.querySelector('input:checked');
          var label = group.querySelector('[data-hah-option-label]');
          if (checked && label) label.textContent = checked.value;
        });
        if (!variant) {
          if (saving) { saving.hidden = true; saving.textContent = ''; }
          if (comparePrice) { comparePrice.hidden = true; comparePrice.textContent = ''; }
          if (atc) {
            atc.disabled = true;
            atc.textContent = 'Unavailable';
          }
          return;
        }
        if (variantInput) variantInput.value = variant.id;
        if (currentPrice) currentPrice.textContent = pricePending ? 'Price to be confirmed' : money(variant.price);
        if (comparePrice) {
          if (!pricePending && conversion.enabled.savings && variant.compare_at_price && variant.compare_at_price > variant.price) {
            comparePrice.hidden = false;
            comparePrice.textContent = money(variant.compare_at_price);
          } else {
            comparePrice.hidden = true;
            comparePrice.textContent = '';
          }
        }
        if (saving) {
          var discount = conversionApi && conversionApi.savings(variant.price, variant.compare_at_price, pricePending, conversion.enabled.savings);
          saving.hidden = !discount;
          saving.textContent = discount ? discount.percent + '% OFF' : '';
        }
        if (atc) {
          atc.disabled = pricePending || !variant.available || hahSubmitting;
          atc.textContent = pricePending ? 'Not available yet' : variant.available ? 'Add to cart' : 'Sold out';
        }
      }

      section.querySelectorAll('[data-hah-option-input]').forEach(function (input) {
        input.addEventListener('change', updateVariant);
      });
      updateVariant();

      var salesBadge = section.querySelector('[data-hah-sales]');
      var deliveryPanel = section.querySelector('[data-hah-delivery]');
      var deliveryCountry = section.querySelector('[data-hah-delivery-country]');
      var deliveryResult = section.querySelector('[data-hah-delivery-result]');
      var deliveryNote = section.querySelector('[data-hah-delivery-note]');
      var deliveryProfile = conversionApi && !pricePending && section.dataset.shippingHidden !== 'true' ?
        conversionApi.deliveryProfile(conversion) : null;
      var conversionTimer = null;
      if (deliveryPanel && deliveryCountry && deliveryProfile) {
        var countryNames = null;
        try { countryNames = new Intl.DisplayNames(['en'], { type: 'region' }); } catch (error) {}
        deliveryProfile.routes.forEach(function (route) {
          var option = document.createElement('option');
          option.value = route.country;
          option.textContent = countryNames ? countryNames.of(route.country) : route.country;
          deliveryCountry.appendChild(option);
        });
        deliveryPanel.hidden = false;
      } else if (deliveryPanel) deliveryPanel.hidden = true;

      function deliveryDate(value) {
        return new Intl.DateTimeFormat('en', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' })
          .format(new Date(value + 'T12:00:00Z'));
      }
      function refreshConversion() {
        if (section.isConnected === false) {
          if (conversionTimer !== null) window.clearInterval(conversionTimer);
          conversionTimer = null;
          if (offersTimer !== null) window.clearTimeout(offersTimer); offersTimer = null;
          return;
        }
        refreshOffers();
        if (salesBadge) {
          var sales = !pricePending && conversionApi && conversionApi.salesInfo(conversion, conversionPayload.sales, Date.now());
          salesBadge.hidden = !sales;
          salesBadge.textContent = sales ? new Intl.NumberFormat('en').format(sales.units) + ' items sold in the last 30 days' : '';
        }
        if (deliveryPanel && deliveryProfile && deliveryCountry && deliveryResult) {
          var estimate = conversionApi.estimateDelivery(deliveryProfile, deliveryCountry.value, Date.now());
          deliveryResult.textContent = estimate ? deliveryDate(estimate.earliest) +
            (estimate.earliest === estimate.latest ? '' : ' – ' + deliveryDate(estimate.latest)) :
            deliveryCountry.value ? 'An estimate is not available for this destination.' : 'Choose your delivery country to see an estimate.';
          if (deliveryNote) {
            deliveryNote.hidden = !estimate;
            deliveryNote.textContent = estimate ? estimate.service + '. Includes production and transit time. Estimated dates may vary.' : '';
          }
        }
      }
      if (deliveryCountry) deliveryCountry.addEventListener('change', refreshConversion);
      refreshConversion();
      if (salesBadge || deliveryProfile || offersNode) conversionTimer = window.setInterval(refreshConversion, 60000);

      // Some alternate product templates omit the review app section. Preserve a
      // useful, truthful anchor using the same existing aggregate, without inventing reviews.
      var reviewLink = section.querySelector('[data-hah-review-link]');
      if (reviewLink) reviewLink.addEventListener('click', function (event) {
        var anchor = reviewLink.hash.slice(1);
        if (!document.getElementById(anchor)) {
          var reviewSummary = document.createElement('section');
          reviewSummary.id = anchor;
          reviewSummary.className = 'hah-detail-review-fallback';
          reviewSummary.setAttribute('data-hah-review-fallback', '');
          reviewSummary.tabIndex = -1;
          var heading = document.createElement('h2');
          heading.textContent = 'Customer reviews';
          var aggregate = document.createElement('p');
          aggregate.textContent = reviewLink.textContent.trim();
          reviewSummary.appendChild(heading);
          reviewSummary.appendChild(aggregate);
          var info = section.querySelector('.hah-product-info');
          if (info) info.appendChild(reviewSummary);
        }
      });

      function syncCustomilyMultiSelects() {
        var isValid = true;
        section.querySelectorAll('[data-hah-multi-group]').forEach(function (group) {
          var checked = Array.from(group.querySelectorAll('[data-hah-multi-option]:checked')).map(function (input) {
            return input.value;
          });
          var hidden = group.parentElement ? group.parentElement.querySelector('[data-hah-multi-value]') : null;
          var firstOption = group.querySelector('[data-hah-multi-option]');
          var isRequired = group.getAttribute('data-hah-multi-required') === 'true';
          if (hidden) hidden.value = checked.join(', ');
          if (firstOption) {
            firstOption.setCustomValidity(isRequired && checked.length === 0 ? 'Please choose at least one option.' : '');
            if (isRequired && checked.length === 0) isValid = false;
          }
        });
        return isValid;
      }

      section.querySelectorAll('[data-hah-multi-option]').forEach(function (input) {
        input.addEventListener('change', syncCustomilyMultiSelects);
      });
      syncCustomilyMultiSelects();

      var gallery = section.querySelector('[data-hah-product-gallery]');
      var galleryMedia = section.querySelector('.hah-product-main-media');
      var thumbs = Array.from(section.querySelectorAll('[data-hah-thumb]'));
      var galleryStatus = section.querySelector('[data-hah-gallery-status]');
      var galleryPrev = section.querySelector('[data-hah-gallery-prev]');
      var galleryNext = section.querySelector('[data-hah-gallery-next]');
      var galleryNextHit = section.querySelector('[data-hah-gallery-next-hit]');
      var galleryTimer = null;
      var galleryInterval = 4200;
      var activeGalleryIndex = thumbs.findIndex(function (thumb) {
        return thumb.classList.contains('is-active');
      });
      if (activeGalleryIndex < 0) activeGalleryIndex = 0;

      function stopGalleryAuto() {
        if (!galleryTimer) return;
        window.clearInterval(galleryTimer);
        galleryTimer = null;
      }

      function startGalleryAuto() {
        if (thumbs.length <= 1 || galleryTimer || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        galleryTimer = window.setInterval(function () {
          setGalleryIndex(activeGalleryIndex + 1, false);
        }, galleryInterval);
      }

      function updateGalleryStatus() {
        if (galleryStatus) galleryStatus.textContent = (activeGalleryIndex + 1) + ' / ' + thumbs.length;
      }

      function clearGalleryDragStyles() {
        [mainImage, activeGalleryImage, bufferGalleryImage].forEach(function (image) {
          if (!image) return;
          image.style.transition = '';
          image.style.transform = '';
          image.style.opacity = '';
        });
        if (galleryMedia) galleryMedia.classList.remove('is-dragging');
      }

      function revealGalleryImage(nextImage, previousImage, token) {
        if (!nextImage || token !== gallerySwitchToken) return;
        window.requestAnimationFrame(function () {
          if (token !== gallerySwitchToken) return;
          nextImage.classList.add('is-active');
          nextImage.removeAttribute('aria-hidden');
          if (previousImage && previousImage !== nextImage) {
            previousImage.classList.remove('is-active');
            previousImage.setAttribute('aria-hidden', 'true');
          }
          activeGalleryImage = nextImage;
          bufferGalleryImage = previousImage;
        });
      }

      function swapGalleryImage(src, srcset, alt) {
        if (!mainImage || !src) return;
        if (!bufferGalleryImage || bufferGalleryImage === activeGalleryImage) {
          bufferGalleryImage = activeGalleryImage === mainImage ? mainImage.nextElementSibling : mainImage;
        }
        var nextImage = bufferGalleryImage;
        var previousImage = activeGalleryImage || mainImage;
        if (!nextImage) {
          nextImage = mainImage;
          previousImage = null;
        }

        var token = ++gallerySwitchToken;
        nextImage.classList.remove('is-active', 'is-switching');
        nextImage.setAttribute('aria-hidden', 'true');
        nextImage.alt = alt;

        var onLoad = function () {
          revealGalleryImage(nextImage, previousImage, token);
        };
        var onError = function () {
          if (token === gallerySwitchToken && previousImage) previousImage.classList.add('is-active');
        };

        nextImage.addEventListener('load', onLoad, { once: true });
        nextImage.addEventListener('error', onError, { once: true });
        if (srcset) {
          nextImage.setAttribute('srcset', srcset);
        } else {
          nextImage.removeAttribute('srcset');
        }
        nextImage.src = src;

        if (nextImage.complete && nextImage.naturalWidth > 0) {
          onLoad();
        }
      }

      function setGalleryIndex(index, userInitiated) {
        if (!mainImage || !thumbs.length) return;
        var nextIndex = (index + thumbs.length) % thumbs.length;
        if (nextIndex === activeGalleryIndex) return;
        clearGalleryDragStyles();
        var thumb = thumbs[nextIndex];
        var src = thumb.getAttribute('data-hah-thumb-src');
        var srcset = thumb.getAttribute('data-hah-thumb-srcset');
        var alt = thumb.getAttribute('data-hah-thumb-alt') || (activeGalleryImage && activeGalleryImage.alt) || mainImage.alt;
        if (!src) return;

        activeGalleryIndex = nextIndex;
        swapGalleryImage(src, srcset, alt);

        thumbs.forEach(function (item, itemIndex) {
          var isActive = itemIndex === activeGalleryIndex;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
        updateGalleryStatus();

        if (userInitiated) {
          stopGalleryAuto();
        }
      }

      function changeGalleryBy(delta, userInitiated, event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
        setGalleryIndex(activeGalleryIndex + delta, userInitiated);
      }

      function prepareSwipeBuffer(direction, deltaX) {
        if (!galleryMedia || !activeGalleryImage || thumbs.length <= 1) return;
        if (!bufferGalleryImage || bufferGalleryImage === activeGalleryImage) {
          bufferGalleryImage = activeGalleryImage === mainImage ? mainImage.nextElementSibling : mainImage;
        }
        if (!bufferGalleryImage) return;
        var targetIndex = (activeGalleryIndex + direction + thumbs.length) % thumbs.length;
        var thumb = thumbs[targetIndex];
        var src = thumb ? thumb.getAttribute('data-hah-thumb-src') : '';
        var srcset = thumb ? thumb.getAttribute('data-hah-thumb-srcset') : '';
        if (!src) return;

        if (bufferGalleryImage.getAttribute('src') !== src) {
          if (srcset) {
            bufferGalleryImage.setAttribute('srcset', srcset);
          } else {
            bufferGalleryImage.removeAttribute('srcset');
          }
          bufferGalleryImage.src = src;
          bufferGalleryImage.alt = thumb.getAttribute('data-hah-thumb-alt') || activeGalleryImage.alt || mainImage.alt;
        }

        var width = galleryMedia.getBoundingClientRect().width || 1;
        galleryMedia.classList.add('is-dragging');
        activeGalleryImage.style.opacity = '1';
        activeGalleryImage.style.transform = 'translateX(' + deltaX + 'px) scale(1)';
        bufferGalleryImage.style.opacity = '1';
        bufferGalleryImage.style.transform = 'translateX(' + ((direction * width) + deltaX) + 'px) scale(1)';
        bufferGalleryImage.removeAttribute('aria-hidden');
      }

      function resetSwipePosition(direction) {
        if (!galleryMedia) return;
        var width = galleryMedia.getBoundingClientRect().width || 1;
        [activeGalleryImage, bufferGalleryImage].forEach(function (image) {
          if (!image) return;
          image.style.transition = 'transform .22s ease, opacity .22s ease';
        });
        if (activeGalleryImage) activeGalleryImage.style.transform = 'translateX(0) scale(1)';
        if (bufferGalleryImage) {
          bufferGalleryImage.style.transform = 'translateX(' + (direction * width) + 'px) scale(1)';
          bufferGalleryImage.setAttribute('aria-hidden', 'true');
        }
        window.setTimeout(clearGalleryDragStyles, 240);
      }

      function initGallerySwipe() {
        if (!galleryMedia || thumbs.length <= 1 || !window.PointerEvent) return;
        var tracking = false;
        var dragging = false;
        var startX = 0;
        var startY = 0;
        var lastX = 0;
        var direction = 1;
        var pointerId = null;

        galleryMedia.addEventListener('pointerdown', function (event) {
          if (event.button && event.button !== 0) return;
          if (event.target && event.target.closest('.hah-product-gallery-arrow, .hah-product-gallery-status')) return;
          tracking = true;
          dragging = false;
          startX = event.clientX;
          startY = event.clientY;
          lastX = event.clientX;
          pointerId = event.pointerId;
          stopGalleryAuto();
          if (galleryMedia.setPointerCapture) {
            try { galleryMedia.setPointerCapture(pointerId); } catch (error) {}
          }
        });

        galleryMedia.addEventListener('pointermove', function (event) {
          if (!tracking || event.pointerId !== pointerId) return;
          var deltaX = event.clientX - startX;
          var deltaY = event.clientY - startY;
          lastX = event.clientX;
          if (!dragging && Math.abs(deltaX) > 10 && Math.abs(deltaX) > Math.abs(deltaY) * 1.15) {
            dragging = true;
          }
          if (!dragging) return;
          event.preventDefault();
          direction = deltaX < 0 ? 1 : -1;
          prepareSwipeBuffer(direction, deltaX);
        });

        function endSwipe(event) {
          if (!tracking || event.pointerId !== pointerId) return;
          var deltaX = lastX - startX;
          var width = galleryMedia.getBoundingClientRect().width || 1;
          tracking = false;
          pointerId = null;
          if (galleryMedia.releasePointerCapture) {
            try { galleryMedia.releasePointerCapture(event.pointerId); } catch (error) {}
          }
          if (!dragging) return;
          dragging = false;
          if (Math.abs(deltaX) > Math.min(86, width * 0.22)) {
            changeGalleryBy(deltaX < 0 ? 1 : -1, true, event);
          } else {
            resetSwipePosition(direction);
          }
        }

        galleryMedia.addEventListener('pointerup', endSwipe);
        galleryMedia.addEventListener('pointercancel', endSwipe);
      }

      thumbs.forEach(function (button, index) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          setGalleryIndex(index, true);
        });
      });
      if (galleryPrev) galleryPrev.addEventListener('click', function (event) { changeGalleryBy(-1, true, event); });
      if (galleryNext) galleryNext.addEventListener('click', function (event) { changeGalleryBy(1, true, event); });
      if (galleryNextHit) galleryNextHit.addEventListener('click', function (event) { changeGalleryBy(1, true, event); });
      if (gallery) {
        gallery.addEventListener('mouseenter', stopGalleryAuto);
        gallery.addEventListener('mouseleave', startGalleryAuto);
        gallery.addEventListener('focusin', stopGalleryAuto);
        gallery.addEventListener('focusout', startGalleryAuto);
      }
      initGallerySwipe();
      updateGalleryStatus();
      startGalleryAuto();

      var qty = section.querySelector('[data-hah-qty]');
      var minus = section.querySelector('[data-hah-qty-minus]');
      var plus = section.querySelector('[data-hah-qty-plus]');
      if (minus && qty) minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
      if (plus && qty) plus.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });

      var shippingLink = section.querySelector('[data-hah-open-shipping]');
      if (shippingLink) shippingLink.addEventListener('click', function () {
        var destination = document.getElementById(shippingLink.hash.slice(1));
        if (destination) destination.open = true;
      });


      // HAH personalizer integration: keep the original single cart submit listener.
      var hahSubmitting = false;
      if (form) {
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          if (hahSubmitting) return;
          if (pricePending) {
            if (message) { message.style.display = 'block'; message.classList.add('is-error'); message.textContent = 'This product is not available to order yet.'; }
            return;
          }
          if (!syncCustomilyMultiSelects()) {
            var invalidMulti = section.querySelector('[data-hah-multi-option]:invalid');
            if (invalidMulti) invalidMulti.reportValidity();
            return;
          }
          if (!form.reportValidity()) return;
          hahSubmitting = true;
          var cartRequestStarted = false;
          var cartDefinitiveFailure = false;
          var cartOutcomeUnknown = false;
          var cartTimer = null;
          // Local diagnostics only: durations/counts, never design values or URLs.
          var clock = function () { return window.performance && window.performance.now ? window.performance.now() : Date.now(); };
          var startedAt = clock(), cartStartedAt = null;
          var timing = { stage: 'preparing' };
          function recordTiming(stage) { timing.stage = stage; form.setAttribute('data-hah-cart-timing', JSON.stringify(timing)); }
          recordTiming('preparing');
          if (atc) {
            atc.disabled = true;
            atc.setAttribute('aria-busy', 'true');
            atc.textContent = 'Saving design…';
          }
          if (message) {
            message.style.display = 'block';
            message.classList.remove('is-error');
            message.textContent = 'Saving your design and adding to cart...';
          }

          Promise.resolve()
            .then(function () {
              var personalizerElement = form.querySelector('[data-hah-personalizer], [data-hah-layered]');
              var data = new FormData(form);
              if (personalizerElement) {
                if (!form.hahPersonalizer || typeof form.hahPersonalizer.prepareFormData !== 'function') {
                  throw new Error('The design preview is still loading. Please refresh this page before adding to cart.');
                }
                return form.hahPersonalizer.prepareFormData(data);
              }
              return data;
            })
            .then(function (data) {
              timing.prepare_ms = Math.round(clock() - startedAt);
              timing.file_bytes = 0; timing.file_count = 0;
              data.forEach(function (value) { if (typeof value !== 'string' && typeof value.size === 'number') { timing.file_bytes += value.size; timing.file_count++; } });
              var savedTransport = data.get('_hah_saved_design_transport') === '1';
              data.delete('_hah_saved_design_transport');
              var requestBody = data, requestHeaders = { Accept: 'application/json' };
              if (savedTransport) {
                var item = { id: data.get('id'), quantity: Number(data.get('quantity') || 1), properties: {} };
                if (data.get('selling_plan')) item.selling_plan = data.get('selling_plan');
                data.forEach(function (value, key) { var match = /^properties\[(.*)\]$/.exec(key); if (match && typeof value === 'string') item.properties[match[1]] = value; });
                requestBody = JSON.stringify(item); requestHeaders['Content-Type'] = 'application/json';
                timing.request_bytes = new TextEncoder().encode(requestBody).length;
                timing.transport = 'saved_design';
              }
              cartStartedAt = clock(); recordTiming('uploading');
              if (message) message.textContent = savedTransport ? 'Adding your saved design to cart…' : 'Uploading your photos and design…';
              if (atc) atc.textContent = 'Adding to cart…';
              var cartRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
              cartRequestStarted = true;
              var controller = typeof AbortController === 'function' ? new AbortController() : null;
              var request = fetch(cartRoot.replace(/\/?$/, '/') + 'cart/add.js', {
                method: 'POST',
                body: requestBody,
                signal: controller ? controller.signal : undefined,
                headers: requestHeaders
              }).then(function (response) {
                if (!response.ok) {
                  cartDefinitiveFailure = response.status < 500;
                  return response.json().catch(function () { return {}; }).then(function (payload) {
                    throw new Error(payload.description || payload.message || 'Unable to add this item.');
                  });
                }
                return response.json();
              });
              return Promise.race([request, new Promise(function (_, reject) {
                cartTimer = window.setTimeout(function () {
                  // A timeout cannot prove that Shopify did not receive the item.
                  cartDefinitiveFailure = false;
                  if (controller) controller.abort();
                  reject(new Error('The cart response timed out.'));
                }, 120000);
              })]);
            })
            .then(function (result) {
              if (!result || !result.key) throw new Error('The cart update could not be confirmed.');
              timing.cart_post_ms = Math.round(clock() - cartStartedAt);
              timing.total_ms = Math.round(clock() - startedAt); recordTiming('added');
              if (message) {
                message.classList.remove('is-error');
                message.textContent = 'Added to cart. Checkout securely in your cart.';
              }
              var designStatus = form.querySelector('[data-hah-personalizer-status], [data-hah-layered-status]');
              if (designStatus) {
                designStatus.classList.remove('is-error');
                designStatus.textContent = 'Added to cart. Your photo and design are saved.';
              }
              document.dispatchEvent(new CustomEvent('hah:cart:open'));
            })
            .catch(function (error) {
              cartOutcomeUnknown = cartRequestStarted && !cartDefinitiveFailure;
              timing.total_ms = Math.round(clock() - startedAt); recordTiming(cartOutcomeUnknown ? 'unconfirmed' : 'failed');
              var errorMessage = cartOutcomeUnknown ? 'We could not confirm the cart update. Check your cart before adding again.' : (error && error.message ? error.message : 'Unable to add this item. Please try again.');
              if (message) {
                message.classList.add('is-error');
                message.textContent = errorMessage;
                if (cartOutcomeUnknown) {
                  var checkCart = document.createElement('a');
                  checkCart.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart';
                  checkCart.textContent = ' Check your cart';
                  message.appendChild(checkCart);
                }
              }
              var designStatus = form.querySelector('[data-hah-personalizer-status], [data-hah-layered-status]');
              if (designStatus) {
                designStatus.classList.add('is-error');
                designStatus.textContent = errorMessage;
              }
            })
            .finally(function () {
              if (cartTimer !== null) window.clearTimeout(cartTimer);
              hahSubmitting = cartOutcomeUnknown;
              updateVariant();
              if (atc) atc.removeAttribute('aria-busy');
            });
        });
      }

    }
    function mountAll(root) {
      if (root.matches && root.matches('[data-hah-product-detail]')) mount(root);
      root.querySelectorAll('[data-hah-product-detail]').forEach(mount);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { mountAll(document); });
    else mountAll(document);
    document.addEventListener('shopify:section:load', function (event) {
      document.querySelectorAll('[data-hah-review-fallback]').forEach(function (fallback) {
        var actual = document.querySelector('.hah-story--reviews[id="' + fallback.id + '"]');
        if (actual) fallback.remove();
      });
      mountAll(event.target);
    });
}());
